import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function SystemDynamics(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>System Dynamics</h2>
            
                <li>
                    <Link to={`${url}/elementaryparts`}>Elementary Parts</Link>
                </li>
                <li>
                    <Link to={`${url}/singledof`}>Single Degree of Freedom</Link>
                </li>
                <li>
                    <Link to={`${url}/freevibrations`}>Free Vibrations</Link>
                </li>
                <li>
                    <Link to={`${url}/forcedvibrations`}>Forced Vibrations</Link>
                </li>      
                <li>
                    <Link to={`${url}/systemkinematics`}>System Kinematics</Link>
                </li>       
                     <li>
                    <Link to={`${url}/resonance`}>Resonance</Link>
                </li>    
                      <li>
                    <Link to={`${url}/mdof`}>Multiple DOF</Link>
                </li>    
                    <li>
                    <Link to={`${url}/modal`}>Modal Analysis</Link>
                </li>  
                     <li>
                    <Link to={`${url}/lagrangian`}>Lagrangian Mechanics</Link>
                </li>  
                     <li>
                    <Link to={`${url}/continuous`}>Continuous Functions</Link>
                </li>  
                   <li>
                    <Link to={`${url}/transfer`}>Transfer Functions</Link>
                </li>  
                  <li>
                    <Link to={`${url}/statespace`}>State Space</Link>
                </li>  
                    <li>
                    <Link to={`${url}/experiments`}>Vibration Measurement & Experiments</Link>
                </li>  
                       <li>
                    <Link to={`${url}/vibrationcontrol`}>Vibration Control</Link>
                </li>  
                   <li>
                    <Link to={`${url}/torsionalvibrations`}>Torsional Vibrations</Link>
                </li>  
                   <li>
                    <Link to={`${url}/nonlinearvibrations`}>Nonlinear Vibrations</Link>
                </li>  
                   <li>
                    <Link to={`${url}/randomvibrations`}>Random Vibrations</Link>
                </li>  
                   <li>
                    <Link to={`${url}/numericalmethods`}>Numerical Methods</Link>
                </li>  
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default SystemDynamics; 